
export const ADD_NOTE = 'ADD_NOTE';
export const SET_EXP_DATA = 'SET_EXP_DATA';
export const SET_EDU_DATA = 'SET_EDU_DATA';
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';
export const SET_SKILLS_DATA = 'SET_SKILLS_DATA';
export const SET_COURSES_DATA = 'SET_COURSES_DATA';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const SET_HOBBY_DATA = 'SET_HOBBY_DATA';



